
import global from '../../../static/js/global.js'
import LoadMore from 'vux/src/components/load-more/index.vue'

export default{
components: {
LoadMore
},
data(){
return{
content:''
}
},
beforeMount(){
/*正式环境*/
let urlnotice = global.host + 'news/getNewsByTypeEqPublic?comnCode=' + this.$router.history.current.query.communityId + '&pageNum=1';
/*测试环境*/


this.$http.get(urlnotice).then(function(res){
if(res.body.result.list){
this.content = res.body.result.list[0].content  + "<style>img{width:100%;height:auto;max-width:100%;}</style>";
}
},function(err){
console.log(err)
})
},
mounted(){
if(this.$router.history.current.path == "/infoPublic"){
document.title = "信息公开";
}
}
}



// WEBPACK FOOTER //
// ./src/components/newComponents/infoPublic.vue